export class OangJsonHelper { 
    public static setPropIfNotExist(obj : any, propName : string, newValue : string) {
        if (! obj.hasOwnProperty("propName")) {
            obj[propName] = newValue;
        } else {
            obj[propName] += newValue;
        }
    }
}
